import "../globals/global.css";
import "./createAccount.css";
import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";

const CreateAccount = () => {
  return (
    <div className="pagebackground">
      <NavigationBar></NavigationBar>
      <PageTitle title="RECRUITMENT CENTER"></PageTitle>
      <div className="pagebox-createaccount">
        <iframe
          src="https://account.hng-group.com/registerplayer_embed.aspx"
          width="100%"
          height="600"
          title="Legacy ASPX"
          allowtransparency="true"
          style={{ border: "none", background: "transparent" }}
        />
      </div>
    </div>
  );
};
export default CreateAccount;
